import { createContext } from 'react';

export type PortConnectionContextValue = {
    connected: boolean;
};

export const PortConnectionContext = createContext<PortConnectionContextValue | undefined>(undefined);
